import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import * as actions from "../../actions";
import * as Constants from "../../constants";
import * as Helper from "../../utils/helper";
import FooterButtons from "../../components/Button/FooterButtons";
import MedicineList from "../../components/ProductDetail/MedicineList";
import ActiveRefills from "../../components/ActiveRefills/ActiveRefills";
import PastOrders from "../../components/PastOrders/PastOrders";
import OrderSubstitutionReasonModal from "../../components/OrderSubstitutionReasonModal/OrderSubstitutionReasonModal";
import Recommendation from "../../components/Recommendation/Recommendation";
import Loader from "@components/Loader";
import { sendToGTM } from "../../utils/gtmHelper";
import "./AddProducts.scss";
import * as AnalyticsHelper from "../../utils/analyticsHelper";

const initialState = {
  searchText: "",
  medicines: [],
  selectedComponentId: 2,
  currentSearchIndex: 0,
  currentRefillsIndex: 0,
  currentPrevMedicinesIndex: 0,
  currentPastOrdersIndex: 0,
  buttonLoading: -1,
  isInputFocused: false,
  pastOrders: [],
  notifiedProductIds: [],
  showSubstitutionReasonPopup: false,
  substitutionReasonType: 0,
  enableAddressSelection: false,
  isRecommendationsShown: false,
  recommendedData: {},
  numberOfRecommendations: 0,
  showRecommendationCard: false,
  cantSuggestRecommendation: false,
  isLoading: false,
};

class AddProducts extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    const alreadyVisitedProductsPage =
      this.props.location.state &&
      this.props.location.state.alreadyVisitedProductsPage;
    this.props.actions.changeHeaderState(Constants.ADD_PRODUCTS);
    this.props.actions.fetchSubstitutedCartItems();
    if(this.props.customer.omsEnabled) {
      this.props.actions.getCartItemsV5();
      this.props.actions.getLoyaltyData({ custom_token: 'profile' });
    } else {
      this.props.actions.getCartItems();
    }
    // TODO: Refactor this data fetch
    if(this.props.customer.omsEnabled) {
      this.props.actions.fetchDeliveredOrdersV5().then(res => {
        this.setState({
          pastOrders: res.orders
        })
      })
    } else {
      this.props.actions.fetchDeliveredOrders().then((res) => {
        if (!res.status) {
          return;
        }
        this.setState({
          pastOrders: res.data,
        });
      });
    }
  }

  componentWillReceiveProps(newProps) {
    const pathname = window.location.pathname;
    const globalAction = newProps.action;
    switch (globalAction.type) {
      case Constants.CLOSE_THIS_TASK:
        this.cancelOrder();
        break;
      case Constants.MOVE_FORWARD:
        globalAction.path == pathname && this.moveToDeliveryAddress();
        break;
      case Constants.MOVE_BACKWARD:
        globalAction.path == pathname && this.backToCustomerInfo();
        break;
      case Constants.MEDICINE_SEARCH:
        globalAction.path == pathname && this.selectComponentTab(0);
        break;
      case Constants.UP_ARROW:
        globalAction.path == pathname && this.moveUp();
        break;
      case Constants.DOWN_ARROW:
        globalAction.path == pathname && this.moveDown();
        break;
      case Constants.TAB_MOVE_LEFT:
        globalAction.path == pathname && this.tabMoveLeft();
        break;
      case Constants.TAB_MOVE_RIGHT:
        globalAction.path == pathname && this.tabMoveRight();
        break;
      case Constants.CHANGE_SEARCH_TEXT:
        globalAction.path == pathname && this.searchProduct(globalAction.text);
        break;
      case Constants.GET_CART_SUCCESS:
      case Constants.GET_CART_V5_SUCCESS:
        this.setState({
          showRecommendationCard: true,
        });
        break;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.recommendedData.products &&
      this.state.recommendedData.products &&
      prevState.recommendedData.products.length > 0 &&
      this.state.recommendedData.products.length === 0
    ) {
      this.getRecommendedItems();
    }
  }

  getRecommendedItems = () => {

    let cartProductIds = [];

    if(this.props.customer.omsEnabled) {
      const {
        cart: { data: { items = []  } = {} },
      } = this.props;

      cartProductIds = items.map((item) => String(item.productId));
    } else {
      const {
        cart: { data: { medicine: { items = [] } = {} } = {} },
      } = this.props;
  
      cartProductIds = items.map((item) => String(item.productId));
    }

    this.setState({
      isLoading: true,
    });

    this.props.actions
      .getRecommendedItems(cartProductIds)
      .then((response) => {
        this.setState({
          isLoading: false,
        });
        const filteredRecommendedProducts =
          response.data && response.data.products
            ? response.data.products.filter(
                (prod) => !cartProductIds.includes(String(prod.productId))
              )
            : [];
        this.setState({
          recommendedData: {
            ...response.data,
            products: filteredRecommendedProducts,
          },
          numberOfRecommendations: response.data.products.length,
          isRecommendationsShown: filteredRecommendedProducts.length > 0,
          showRecommendationCard: response.data.products.length > 0,
        });
        if (filteredRecommendedProducts.length === 0) {
          this.enableAddressSelection();
        }
      })
      .catch(() => {
        this.enableAddressSelection();
        this.setState({
          isLoading: false,
        });
      });
  };


  closeRecommendations = () => {
    this.setState({
      isRecommendationsShown: false,
    });
  }

  handleRecommendationsBtnClick = () => {
    if (this.state.isRecommendationsShown) {
      this.closeRecommendations();
    } else {
      this.getRecommendedItems();
      const eventObj = {
        eventLabel: Constants.RECOMMENDATION_BUTTON_CLICKED,
        source: Constants.RECOMMENDATION_SOURCE,
        eventDetails: {
          ...AnalyticsHelper.getCommonPayloadForAnalytics(
            this.props.customer,
            this.props.cart,
            this.props.user
          ),
          source: Constants.RECOMMENDATION_SOURCE,
          page_name: "ooc_cart",
          property_section_name: "body",
          property_name: "ooc_recommendation_bar",
          property_cta: "show_products",
          action_type: "click",
        },
      };
      sendToGTM(eventObj);
    }
  };

  removeRecommendedItem = (item) => {
    const newRecommendationCount = this.state.numberOfRecommendations - 1;
    this.setState((prevState) => ({
      recommendedData: {
        ...prevState.recommendedData,
        products: prevState.recommendedData.products.filter(
          (prod) => prod.productId !== item.productId
        ),
      },
      numberOfRecommendations: newRecommendationCount,
      isRecommendationsShown: newRecommendationCount > 0,
      showRecommendationCard: newRecommendationCount > 0,
    }));
  };

  enableAddressSelection = () => {
    this.setState({
      enableAddressSelection: true,
    });
  };

  searchProduct = (value) => {
    this.setState({ searchText: value });
    Helper.debouncePE(400, () => {
      const trimmedValue = value.trim();
      if (trimmedValue) {
        return this.props.actions.searchProducts({ q: trimmedValue });
      }
      return this.props.actions.clearSearchedProducts();
    }
    );
    this.state.selectedComponentId == 0 &&
      this.setState({ currentSearchIndex: 0 });
  };

  tabMoveLeft() {
    if (this.state.selectedComponentId > 0) {
      this.setState({ selectedComponentId: --this.state.selectedComponentId });
      this.state.selectedComponentId === 0 &&
        setTimeout(() => {
          this.nameInput && this.nameInput.focus();
        }, 300);
    }
  }
  tabMoveRight() {
    this.nameInput.blur();
    if (this.state.selectedComponentId <= 2) {
      this.setState({ selectedComponentId: ++this.state.selectedComponentId });
    }
  }

  addSelectedItem() {
    switch (this.state.selectedComponentId) {
      case 0:
        this.setState({ isInputFocused: true });
        break;
      case 1:
        const refills = this.props.refills.data && this.props.refills.data.data;
        const refill = refills[this.state.currentRefillsIndex];
        this.props.actions.openCMSUrlSubscription(
          `${Constants.CMS_URL_SUBSCRIPTION}?id=${refill.detail.id}`
        );
        break;
      case 2:
        const deliveredMedicines =
          this.props.deliveredMedicines.data &&
          this.props.deliveredMedicines.data.data &&
          this.props.deliveredMedicines.data.data.products;
        this.setState({ isInputFocused: true });
        break;
      case 3:
        const detail = this.state.pastOrders[this.state.currentPastOrdersIndex];
        if ('canReorder' in detail && !detail.canReorder) {
          alert("You cant add medicines from this Order!");
          return;
        }
        this.reorder(detail.id, detail.isNewOrderFlow);
        break;
    }
  }
  reorder(orderId) {
    Helper.addAllMedicines(this.props.actions, orderId, isNewOrderFlow);
  }

  scrollUp() {
    this.medicineContainer.scrollTop =
      document.querySelectorAll(".ActiveItem")[0].offsetTop -
      this.medicineContainer.clientHeight;
  }
  scrollDown() {
    this.medicineContainer.scrollTop =
      document.querySelectorAll(".ActiveItem")[0].offsetTop -
      this.medicineContainer.clientHeight +
      this.medicineContainer.clientHeight / 2;
  }

  moveUp() {
    let indexDifference;
    switch (this.state.selectedComponentId) {
      case 0:
        this.state.currentSearchIndex > 0 &&
          this.setState({
            currentSearchIndex: this.state.currentSearchIndex - 1,
          });
        this.scrollUp();
        break;
      case 1:
        this.state.currentRefillsIndex > 0 &&
          this.setState({
            currentRefillsIndex: this.state.currentRefillsIndex - 1,
          });
        this.scrollUp();
        break;
      case 2:
        this.state.currentPrevMedicinesIndex > 0 &&
          this.setState({
            currentPrevMedicinesIndex: this.state.currentPrevMedicinesIndex - 1,
          });
        this.scrollUp();
        break;
      case 3:
        this.state.currentPastOrdersIndex > 0 &&
          this.setState({
            currentPastOrdersIndex: this.state.currentPastOrdersIndex - 1,
          });
        this.scrollUp();
        break;
    }
  }

  moveDown() {
    let length, indexDifference;
    const { deliveredMedicines, refills } = this.props;
    switch (this.state.selectedComponentId) {
      case 0:
        let {
          products: {
            searchResults: {
              data: { products: products },
            },
          },
        } = this.props;
        length = products.length;
        this.state.currentSearchIndex < length - 1 &&
          this.setState({
            currentSearchIndex: this.state.currentSearchIndex + 1,
          });
        this.scrollDown();
        break;
      case 1:
        length = refills.data && refills.data.data && refills.data.data.length;
        this.state.currentRefillsIndex < length - 1 &&
          this.setState({
            currentRefillsIndex: this.state.currentRefillsIndex + 1,
          });
        this.scrollDown();
        break;
      case 2:
        length =
          deliveredMedicines.data &&
          deliveredMedicines.data.data &&
          deliveredMedicines.data.data.products.length;
        this.state.currentPrevMedicinesIndex < length - 1 &&
          this.setState({
            currentPrevMedicinesIndex: this.state.currentPrevMedicinesIndex + 1,
          });
        this.scrollDown();
        break;
      case 3:
        length = this.state.pastOrders.length;
        this.state.currentPastOrdersIndex < length - 1 &&
          this.setState({
            currentPastOrdersIndex: this.state.currentPastOrdersIndex + 1,
          });
        this.scrollDown();
        break;
    }
  }

  notifyDTPProduct = (productId) => {
    const { notifiedProductIds } = this.state;
    return this.props.actions
      .notifyCustomerDTP(productId)
      .then(({ status }) => {
        if (!status) {
          alert("Failed to add notification opt-in");
          return;
        }
        this.setState({
          notifiedProductIds: [productId, ...notifiedProductIds],
        });

        return true;
      });
  };

  backToCustomerInfo = () => {
    browserHistory.push({
      pathname: "/customer-info",
      state: { alreadyVisitedCustomerInfoPage: true },
    });
  };

  moveToDeliveryAddress = () => {

    let cartItems = [];
    
    if(this.props.customer.omsEnabled) {
      const {
        cart: { data: { items = [] } = {} },
      } = this.props;
      cartItems = items;
    } else {
      const {
        cart: { data: { medicine: { items = [] } = {} } = {} },
      } = this.props;
      cartItems = items;
    }

    let showSubstitutionReasonPopup = false;
    let substitutionReasonType = 0;

    for (let medItem of cartItems) {
      if (medItem.substitutionInfo) {
        showSubstitutionReasonPopup = true;
        substitutionReasonType = Constants.REASON_TYPE_CONVERTED;
        break;
      }
      if (medItem.availabilityLevel == Constants.availabilityLevelEnum.YELLOW && !medItem.isCustom) {
        // Yellow
        showSubstitutionReasonPopup = true;
        substitutionReasonType = Constants.REASON_TYPE_NOT_CONVERTED;
      }
    }

    if (showSubstitutionReasonPopup) {
      this.setState({
        showSubstitutionReasonPopup,
        substitutionReasonType,
      });

      return;
    }

    this.handleSubstitutionReasonSubmit([]);
  };

  handleSubstitutionReasonSubmit = (reasons) => {
    this.props.actions.saveSubstitutionReasons(reasons);

    browserHistory.push("/select-address");
  };

  cancelOrder = () => {
    if (confirm("Are you sure you want to cancel this order ?")) {
      this.reset();
      this.props.actions.cancelOrder();
      browserHistory.push("/customer-info");
    }
  };
  reset = () => {
    this.setState(initialState);
  };

  selectComponentTab = (id, tabName) => {
    this.setState({ selectedComponentId: id });
    id == 0 &&
      setTimeout(() => {
        this.nameInput && this.nameInput.focus();
      }, 300);
  };
  handleKeyUp(event) {
    switch (event.which) {
      case 221:
        this.nameInput.blur();
        break;
      case 13:
        this.addSelectedItem();
        break;
      case 40:
        this.moveDown();
        break;
      case 38:
        this.moveUp();
        break;
    }
  }

  resetInputFocus = () => {
    this.setState(
      {
        isInputFocused: false,
      },
      () => this.nameInput && this.nameInput.focus()
    );
  };

  handleCantSuggestCta = () => {
    if (!this.state.cantSuggestRecommendation) {
      this.enableAddressSelection();
      this.setState({
        cantSuggestRecommendation: true,
      });
      const eventObj = {
        eventLabel: Constants.RECOMMENDATION_COULD_NOT_SUGGEST,
        source: Constants.RECOMMENDATION_SOURCE,
        eventDetails: {
          ...AnalyticsHelper.getCommonPayloadForAnalytics(
            this.props.customer,
            this.props.cart,
            this.props.user
          ),
          source: Constants.RECOMMENDATION_SOURCE,
          page_name: "ooc_cart",
          property_section_name: "body",
          property_name: "ooc_recommendation_bar",
          property_cta: "could_not_suggest",
          action_type: "click",
        },
      };
      sendToGTM(eventObj);
    }
  };

  render() {
    const {
      searchText,
      selectedComponentId,
      pastOrders,
      notifiedProductIds,
      showSubstitutionReasonPopup,
      substitutionReasonType,
      showRecommendationCard,
      isLoading,
      cantSuggestRecommendation,
    } = this.state;

    const {
      actions: { getSubstitutionReasons },
      products: { searchResults },
    } = this.props;

    let { refills, deliveredMedicines, deliveredOrders } = this.props;
    const tabButtonArray = [
      {},
      { tabClass: "ActiveRefills", tabName: "Active Refills" },
      { tabClass: "PastOrderedMedicines", tabName: "Prev. Ordered Medicines" },
      { tabClass: "PastOrders", tabName: "Past Orders" },
    ];
    return (
      <div className="AddProductsContainer">
        {/*<div className="skipStepLink">
            <Link to="/select-address">Skip this step</Link>
          </div>*/}
        <div onClick={this.closeRecommendations}>
          <div className="AddProductsSearchContainer">
            <input
              type="text"
              className="CustomerInput"
              value={searchText}
              ref={(input) => {
                this.nameInput = input;
              }}
              onFocus={() => this.selectComponentTab(0)}
              onClick={() => this.selectComponentTab(0)}
              onKeyUp={this.handleKeyUp.bind(this)}
              placeholder="Search for product name"
              onChange={(event) => this.searchProduct(event.target.value)}
            />
            <div className="TabButtonGroup">
              {tabButtonArray.map(({ tabClass, tabName }, key) => {
                if (!tabName) {
                  return;
                }
                return (
                  <div
                    key={key}
                    role="button"
                    tabIndex={0 - key}
                    onClick={() => this.selectComponentTab(key, tabName)}
                    className={
                      `AddProductsCommonTabs ${tabClass} ` +
                      (selectedComponentId == key ? "ActiveComponent" : "")
                    }
                  >
                    {tabName}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="TabContentContainer">
            {searchResults && selectedComponentId == 0 && (
              <div
                tabIndex="0"
                ref={(div) => {
                  this.medicineContainer = div;
                }}
                className={
                  "SearchedMedicineContainer " +
                  (this.state.isRecommendationsShown ? "ShorterHeight" : "")
                }
              >
                <MedicineList
                  buttonLoading={this.state.buttonLoading}
                  currentIndex={this.state.currentSearchIndex}
                  isInputFocused={this.state.isInputFocused}
                  resetInputFocus={this.resetInputFocus}
                  medicines={
                    searchResults && searchResults.data
                      ? searchResults.data.products
                      : []
                  }
                  isSearching={this.props.products.isSearching}
                  notifiedProductIds={notifiedProductIds}
                  notifyDTPProduct={this.notifyDTPProduct}
                  searchText={searchText}
                />
              </div>
            )}
            {selectedComponentId == 1 && (
              <div
                ref={(div) => {
                  this.medicineContainer = div;
                }}
                tabIndex="0"
                className={
                  "SearchedMedicineContainer " +
                  (this.state.isRecommendationsShown ? "ShorterHeight" : "")
                }
              >
                {!refills.loading ? (
                  <ActiveRefills
                    buttonLoading={this.state.buttonLoading}
                    actions={this.props.actions}
                    currentIndex={this.state.currentRefillsIndex}
                    refills={
                      (refills && refills.data && refills.data.data) || []
                    }
                  />
                ) : (
                  <div>Fetching data...</div>
                )}
              </div>
            )}
            {selectedComponentId == 2 && (
              <div
                ref={(div) => {
                  this.medicineContainer = div;
                }}
                tabIndex="0"
                className={
                  "SearchedMedicineContainer " +
                  (this.state.isRecommendationsShown ? "ShorterHeight" : "")
                }
              >
                {!deliveredMedicines.loading ? (
                  <MedicineList
                    buttonLoading={this.state.buttonLoading}
                    currentIndex={this.state.currentPrevMedicinesIndex}
                    medicines={
                      (deliveredMedicines &&
                        deliveredMedicines.data &&
                        deliveredMedicines.data.data &&
                        deliveredMedicines.data.data.products) ||
                      []
                    }
                    isInputFocused={this.state.isInputFocused}
                    notifiedProductIds={notifiedProductIds}
                    notifyDTPProduct={this.notifyDTPProduct}
                  />
                ) : (
                  <div>Fetching data...</div>
                )}
              </div>
            )}
            {selectedComponentId == 3 && (
              <div
                ref={(div) => {
                  this.medicineContainer = div;
                }}
                tabIndex="0"
                className={
                  "SearchedMedicineContainer " +
                  (this.state.isRecommendationsShown ? "ShorterHeight" : "")
                }
              >
                {!deliveredOrders.loading ? (
                  <PastOrders
                    buttonLoading={this.state.buttonLoading}
                    currentIndex={this.state.currentPastOrdersIndex}
                    pastOrders={pastOrders}
                  />
                ) : (
                  <div>Fetching data...</div>
                )}
              </div>
            )}
          </div>
        </div>
        <OrderSubstitutionReasonModal
          onClose={() =>
            this.setState({
              showSubstitutionReasonPopup: false,
              substitutionReasonType: 0,
            })
          }
          substitutionReasonType={substitutionReasonType}
          onSubmit={this.handleSubstitutionReasonSubmit}
          getSubstitutionReasons={getSubstitutionReasons}
          show={showSubstitutionReasonPopup}
        />
        {showRecommendationCard && (
          <Recommendation
            onClick={this.handleRecommendationsBtnClick}
            data={this.state.recommendedData}
            isRecommendationsShown={this.state.isRecommendationsShown}
            enableAddressSelection={this.enableAddressSelection}
            removeRecommendedItem={this.removeRecommendedItem}
            recommendationDetails={
              this.props.cart.data && this.props.cart.data.recommendationDetails
                ? this.props.cart.data.recommendationDetails
                : {}
            }
            cantSuggestRecommendation={cantSuggestRecommendation}
            handleSuggestBtn={this.handleCantSuggestCta}
          />
        )}
        <FooterButtons
          backBtnText="Back to Customer Info"
          backBtnClick={() => this.backToCustomerInfo()}
          proceedBtnClick={() => this.moveToDeliveryAddress()}
          proceedBtnText="Select Delivery Address"
          nextStateAllowed={this.state.enableAddressSelection}
          cancelBtnClick={() => this.cancelOrder()}
          cancelBtnText="Cancel Order"
        />
        {(isLoading ||
          (this.props.cart.loading && this.state.isRecommendationsShown)) && (
          <Loader />
        )}
      </div>
    );
  }
}

AddProducts.propTypes = {
  customerDetails: PropTypes.object,
  deliveredOrders: PropTypes.object,
  deliveredMedicines: PropTypes.object,
  products: PropTypes.object,
  refills: PropTypes.object,
  actions: PropTypes.object,
};

AddProducts.defaultProps = {
  deliveredMedicines: {},
  customerDetails: {},
  deliveredOrders: {},
  products: {},
  refills: {},
  actions: {},
};

export default connect(
  (state) => ({
    customerDetails: state.customerDetails,
    deliveredMedicines: state.deliveredMedicines,
    deliveredOrders: state.deliveredOrders,
    products: state.product,
    refills: state.refill,
    action: state.action,
    cart: state.cart,
    customer: state.customer,
    user: state.user,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(AddProducts);
